// API Configuration
//
// Retorna a origem base para chamadas à API. As rotas já incluem o prefixo
// "/api/..." no call-site (ex: `${getApiUrl()}/api/auth/login`), então
// este helper retorna apenas a origem (sem "/api").
//
// Estratégia:
// - localhost / 127.0.0.1  → dev puro → backend direto em localhost:3005
// - qualquer outro host     → string vazia → URL relativa, resolvida pelo proxy
//                             do Vite (dev via Docker) ou pelo Nginx (produção HTTPS)
export const getApiUrl = (): string => {
  if (typeof window === 'undefined') return '';
  const h = window.location.hostname;
  if (h === 'localhost' || h === '127.0.0.1') {
    return 'http://localhost:3005';
  }
  return '';
};

export const API_URL = getApiUrl();

export const getApiBaseUrl = (): string => {
  const origin = getApiUrl().replace(/\/+$/, '');
  return origin ? `${origin}/api` : '/api';
};

export const getAuthHeaders = (): Record<string, string> => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};
